// Shared by HR & Workforce and Accounts & Ledger: push their figures into the ONE
// report store (sustina-reporting) so typed, uploaded and connector values all land
// in the same tables, each with its provenance. Draft sections are left untouched.
import { feedSections } from "../site-admin/report_management/blueprint/reportDataService";

/** sections = [{ topicKey, pillarCode, values: [{path, value, unit, sourceCode, sourceRef}] }] → a one-line outcome. */
export async function feedReport(companyId, from, to, sections) {
  const withValues = sections.filter((s) => s.values.length > 0);
  if (!withValues.length) return "";
  try {
    const res = await feedSections(companyId, from, to, withValues);
    const changed = res.reduce((n, r) => n + (r.changedCount || 0), 0);
    const skipped = res.filter((r) => r.skippedAsDraft).map((r) => r.topicKey);
    return `Report updated: ${changed} value(s) across ${res.length - skipped.length} section(s)`
      + (skipped.length ? `; ${skipped.length} Draft section(s) left unchanged (${skipped.join(", ")}) — change those on the topic form with a reason.` : ".");
  } catch (err) {
    return `Figures saved here, but the report store could not be updated: ${err?.message || err}`;
  }
}
